/* =====================================================
   Numdle React Application Entry Point – Version 2.1 (Modified: July 31, 2025)
   Date Modified: 31 July 2025 | Time: Current
   🔄 Changes from Version 1.9:
     - Complete conversion from vanilla JS to React
     - Modern React hooks and functional components
     - Optimized state management with useState/useEffect
     - Enhanced performance with useMemo and useCallback
     - Component-based architecture for better maintainability
     - CSS Modules for scoped styling
     - Vite build system for faster development
===================================================== */

import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
   
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,

)

